<template>
  <common-dialog ref="dialog" width="80%" title="打印快递单" :data="data" :confirm-on-close-change="false"
    @closed="onClosed">
    <template slot="form">
      <el-row>
        <el-col :span="8">
          <el-form-item label="选择打印机">
            <el-select v-model="data.printer" placeholder="请选择" clearable>
              <el-option v-for="(i, k) in printerList" :key="k" :label="i.name" :value="i.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="是否拆单">
            <el-checkbox v-model="data.separate" @change="onSeparateChange"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="0">
            <div style="display: flex;">
              <div style="margin-right: 10px;">每笔订单获取</div>
              <el-input-number v-model="data.separateNumber" :min="2" :precision="0"
                :disabled="!data.separate"></el-input-number>
              <div style="margin-left: 10px;">个电子面单号</div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <el-form-item label="剩余单数">
            <span style="color: #D9001B;">{{ data.surplusCount }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="19">
          <el-form-item label="申请打印数">
            <span style="color: #D9001B;">{{ data.printCount }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5" v-if="!data.isPrint">
          <el-form-item label="自动发货">
            <el-checkbox v-model="data.autoSend"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="19">
          <el-form-item label="默认发货地址" label-width="100px">
            <el-select v-model="data.address" placeholder="请选择" clearable>
              <el-option v-for="(i, k) in senderAddress" :key="k" :label="i.address" :value="i.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="data.rows" border class="merge-table" max-height="500">
            <el-table-column prop="date" label="收货地址" min-width="350">
              <template slot-scope="{row}">
                <div class="merge-item">
                  <span>{{ row.receiverName }}，{{ row.receiverPhone }}，</span>
                  <span>{{ row.province || '' }}{{ row.city || '' }}{{ row.district || '' }}{{ row.town || '' }}</span>
                  <span>{{ row.address || '' }}</span>
                </div>
                <!-- <div class="merge-item" v-if="row.Id!=2">周**，17****199，江苏省苏州市吴中区江苏省苏*******建工恒泰项目部</div>
                <div class="merge-item" v-else>
                  <div class="badge badge-merge">合单4</div>
                  <span>陈**, 172*****406，江苏省/南通市/如东县/双逸创业园区******</span>
                </div> -->
              </template>
            </el-table-column>
            <el-table-column prop="name" label="订单号" width="200">
              <template slot-scope="{row}">
                <div class="merge-item">{{ row.orderSn }}</div>
                <!-- <template v-if="row.Id == 2">
                  <div class="merge-item">240318-529897952651816</div>
                  <div class="merge-item">240318-529897952651000</div>
                  <div class="merge-item">240318-529897952651111</div>
                </template> -->
                <!-- <template v-else>
                  <div class="merge-item">240316-535486831503318</div>
                </template> -->
              </template>
            </el-table-column>
            <el-table-column prop="Field8" label="运单号" width="200">
              <div slot-scope="{row}" class="merge-item">
                <span>{{ row.expressNumber || '无' }}</span>
                <!-- <template v-if="row.Field8 && row.Field8.length > 0">
                  <div v-for="(i1, k1) in row.Field8" :key="k1">
                    <div>{{ i1.Field8_1 }}：</div>
                    <div v-for="(i2, k2) in i1.Field8_2" :key="k2">{{ i2.Field8_2_1 }}</div>
                  </div>
                </template>
                <span v-else>无</span> -->
              </div>
            </el-table-column>
            <el-table-column prop="address" label="打印状态" width="90">
              <div slot-scope="{row}" class="merge-item">{{ row.isPrint ? '已打印' : '未打印' }} </div>
            </el-table-column>
            <el-table-column prop="address" label="发货状态" width="90">
              <template slot-scope="{row}">
                <div class="merge-item">{{ row.lastShipTime ? '已发货' : '未发货' }} </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="90" v-if="data.isPrint">
              <template slot-scope="{row}">
                <el-button type="text" @click="onPrintAfresh(row)">重新打印</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </template>
    <template slot="footer">
      <div v-if="isDev" style="display: inline-block;margin-right: 10px;">
        <span style="margin-right: 10px;">预览</span>
        <el-switch v-model="preview"></el-switch>
      </div>
      <template v-if="!data.isPrint">
        <el-button v-if="data.autoSend" type="success" @click="onPrintAndSend">获取单号打印并发货</el-button>
        <el-button v-else type="primary" @click="onPrint">获取新单号并打印</el-button>
      </template>
      <template v-else>
        <el-button type="primary" @click="onBatchPrintAfresh()">
          {{ data.rows.length > 1 ? '批量重新打印' : '重新打印' }}
        </el-button>
        <!-- <el-button type="warning" @click="onAddNewNumberPrint">添加新单号打印</el-button> -->
      </template>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import { nanoid } from 'nanoid';
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      // api: require('@/api/wx/malladdresses').default,
      orderApi: require('@/api/wx/order').default,
      malladdressesApi: require('@/api/wx/malladdresses').default,
      logisticsApi: require('@/api/wx/logistics').default,
      socket: null,
      data: {
        id: 0,
        isPrint: false, //是否已打印
        printer: "", //打印机
        separate: false, //拆单
        separateNumber: 2,
        surplusCount: 0, //剩余单数
        printCount: 0, //申请打印数
        autoSend: false, //自动发货
        address: "", //默认发货地址
        rows: []
      },
      senderAddress: [],
      //打印数据
      requestId: nanoid(10),
      printerList: [],
      printData: [],
      preview: false
    };
  },
  computed: {
    isDev() {
      return process.env.NODE_ENV == "development";
    }
  },
  mounted() { },
  methods: {
    setData(data) {
      console.log("setData", data);
      this.data.printCount = data.rows.length;
      this.data.isPrint = data.isPrint;
      this.data.autoSend = data.autoSend;
      this.data.rows = data.rows;
      this.getSenderAddress();
      this.onInitWs();
    },
    getSenderAddress() {
      this.senderAddress.push({
            id: 1,
            address: "韵达 王先生 13396088542 广东省广州市天河区燕富路19号燕塘乳业院内韵达快递1号仓"
          })

      // return new Promise((resolve, reject) => {
      //   this.logisticsApi.getSendaddress({}).then(res => {
      //     // this.senderAddress = res.data.map(x => {
      //     //   var addr = x.fullAddress.replaceAll("^^^", "")
      //     //   return {
      //     //     ...x,
      //     //     address: x.companyName + " " + x.sendGoodsContactor + " " + x.mobile + " " + addr
      //     //   }
      //     // });
      //     this.senderAddress.push({
      //       id: 1,
      //       address: "韵达 王先生 13396088542 广东省广州市天河区燕富路19号燕塘乳业院内韵达快递1号仓"
      //     })
      //     console.log("this.senderAddress", this.senderAddress)
      //     resolve({ code: 0, data: res.data, count: res.count })
      //   }).catch(err => {
      //     resolve({ code: 1, data: [] })
      //   })
      // })
    },
    //初始化websocket (要打开pdd打印组件，websocket才能连接上)
    onInitWs() {
      this.socket = new WebSocket("ws://127.0.0.1:13528"); // Ali
      // this.socket = new WebSocket("ws://127.0.0.1:5000"); // Pdd
      // 添加WebSocket事件监听器
      this.socket.addEventListener("open", this.onSocketOpen);
      this.socket.addEventListener("message", this.onSocketMessage);
      this.socket.addEventListener("close", this.onSocketClose);
      this.socket.addEventListener("error", this.onSocketError);
      // console.log("初始化", this.socket);
    },
    onSocketOpen() {
      console.log("WebSocket连接已打开");
      //获取本地打印机列表
      let data = {
        cmd: "getPrinters",
        requestID: "123458976",
        version: "1.0",
      };
      this.socket.send(JSON.stringify(data));
    },
    onSocketMessage(event) {
      const result = JSON.parse(event.data);
      console.log("收到WebSocket消息:", result);
      if (result.previewImage) {
        result.previewImage.forEach(x => console.log("image:", x))
      }
      // console.log(result.cmd);
      if (result.cmd == "getPrinters") {
        this.printerList = result.printers;
      }
      // if (result.cmd == "print") {
      //   console.log("打印信息");
      // }
      if (result.cmd == "print") {
        console.log("打印结果通知");
        if (result.taskStatus == "failed") {
          this.$message.error("打印失败");
        } else {
          this.$message.success("打印成功");
          if (!this.data.autoSend) this.close();
        }
        // if (result.taskStatus == "success") {
        //   this.$message.success("打印成功");
        // }
      }
      // if (result.cmd == "PrintResultNotify") {
      //   console.log("打印结果通知");
      //   this.socket.close();
      // }
    },
    onSocketClose() {
      console.log("WebSocket连接已关闭");
    },
    onSocketError(event) {
      console.error("WebSocket连接错误:", event);
    },
    onSeparateChange() {
      this.data.separateNumber = 2;
    },
    onPrintAndSend() {
      console.log("打印并发货");
      this.onPrint().then(res => {
        var sendOrders = this.data.rows.map(x => {
          return {
            orderSn: x.orderSn,
            mailNo: x.expressNumber,
            cpCode: "YUNDA",
            logisticsCpName: "韵达"
          }
        });
        this.orderApi.send({ sendOrders }).then(res => {
          if (res && res.length > 0) {
            this.$message({
              type: "error",
              dangerouslyUseHTMLString: true,
              message: (res.map(x => { return '<div>' + x + '</div>' })).join('<br />'),
            })
          } else {
            this.$emit("send-success", sendOrders.map(x => x.orderSn));
            this.close();
          }
        })
      })
    },
    onPrintAfresh(row) {
      if (!row.expressNumber) {
        this.$message.error("当前无运单号，请重新取号打印");
        return;
      }
      console.log("重新打印", row);
      this.onBatchPrintAfresh(row);
    },
    onBatchPrintAfresh(row = null) {
      console.log("批量重新打印");
      if (!this.data.printer) {
        this.$message.warning("请选择打印机")
        return;
      }

      var rows = [];
      if (row == null) {
        rows = this.data.rows;
      } else {
        rows = [row];
      }

      console.log("rows", rows)

      var ids = rows.map(x => x.id);

      this.orderApi.print({ ids, addressId: 1, orderType: 0 }).then(data => {
        this.$emit("reload");
        this.startPrint(data);
      })
    },
    onAddNewNumberPrint() {
      console.log("添加新单号打印");

    },
    onPrint() {
      console.log("打印");
      // this.orderApi.test().then(res => {
      //   console.log("res", res)
      //   if (res.length > 0) {
      //     console.log("print", JSON.parse(res[0].print_data))
      //   }
      // })
      if (!this.data.printer) {
        this.$message.warning("请选择打印机")
        return;
      }

      if (!this.data.address) {
        this.$message.warning("请选择默认发货地址");
        return;
      }

      var ids = this.data.rows.map(x => x.id);

      return new Promise((resolve, reject) => {
        this.orderApi.print({ ids, addressId: this.data.address, orderType: 0 }).then(data => {
          this.$emit("reload");
          // var data = [
          //   {
          //     "success": true,
          //     "error_msg": "",
          //     "order_sn": "2216970805409010299",
          //     "waybill_code": "434048716839513",
          //     "print_data": "{\"data\":{\"_dataFrom\":\"waybill\",\"_page_config\":{\"REQUEST_LAYERED_IMAGE\":false},\"adsInfo\":{\"adId\":\"3\",\"advertisementType\":\"DEFAULT\",\"bannerUrl\":\"https://ad-cdn.cainiao.com/img/3/1719802275085_469.png\",\"miniBannerUrl\":\"https://ad-cdn.cainiao.com/img/3/1719802270074_327.png\",\"useCustomArea\":false},\"cpCode\":\"YUNDA\",\"extraInfo\":{\"appKey\":\"24886256\",\"templateAdDisplayUp\":true},\"needEncrypt\":false,\"orderChannelsType\":\"TB\",\"packageInfo\":{\"goodsDescription\":\"服装\",\"id\":\"2216970805409010299\",\"items\":[{\"count\":1,\"name\":\"自由打单\"}],\"volume\":0,\"weight\":0},\"parent\":false,\"realCpCode\":\"YUNDA\",\"recipient\":{\"address\":{\"city\":\"深圳市\",\"detail\":\"深圳市龙岗区布吉街道华美工业区综合楼*\",\"district\":\"龙岗区\",\"province\":\"广东省\"},\"mobile\":\"13396088542\",\"name\":\"刘*\"},\"routingExtraInfo\":{},\"routingInfo\":{\"consolidation\":{\"code\":\"J999633\",\"name\":\"深东地区包-珠三角9城\"},\"endCodeId\":\"DUODUOMAICAI|A007294035\",\"endCodeType\":\"3\",\"exchangeAreaCode\":\"广州-小库-省内件\",\"omsSortingData\":{},\"origin\":{\"code\":\"680206\",\"name\":\"广东广州天河区梅花园公司\"},\"receiveBranch\":{\"code\":\"518230\",\"name\":\"广东深圳公司龙岗区南岭直营分部\"},\"routeCode\":\"B234-00 K8\",\"sortation\":{\"name\":\"672C\"},\"startCenter\":{},\"terminalCenter\":{}},\"sender\":{\"address\":{\"city\":\"广州市\",\"detail\":\"燕富路19号燕塘乳业院内韵达快递1号仓\",\"district\":\"天河区\",\"province\":\"广东省\"},\"mobile\":\"13396088542\",\"name\":\"王先生\"},\"shippingOption\":{\"code\":\"STANDARD_EXPRESS\",\"title\":\"标准快递\"},\"waybillCode\":\"434048716839513\"},\"signature\":\"MD:yO06e18pNkDqgC2la6oWqw==\",\"templateURL\":\"http://cloudprint.cainiao.com/template/standard/288658\",\"ver\":\"waybill_print_secret_version_1\"}",
          //     "parent_waybill_code": ""
          //   }
          // ]
          data.forEach(x => {
            var order = this.data.rows.find(w => w.orderSn == x.order_sn);
            order.expressNumber = x.waybill_code;
          })
          this.startPrint(data);
          resolve();
        }).catch(err => {
          reject(err);
        })
      })
    },
    startPrint(rows) {
      var data = {
        cmd: "print",
        requestID: this.requestId,
        version: "1.0",
        task: {
          taskID: new Date().getTime().toString(),
          preview: this.preview,
          previewType: "image",
          printer: this.data.printer,
          documents: [],
        }
      }

      var docs = [];

      rows.forEach(x => {
        var printData = JSON.parse(x.print_data);
        console.log("printData", printData);
        docs.push({
          documentID: x.waybill_code,
          contents: [
            {
              data: { ...printData.data },
              signature: printData.signature,
              templateURL: printData.templateURL,
              ver: printData.ver
            },
            // {
            //   data: {
            //     value: "测试字段值需要配合自定义区变量名"
            //   },
            //   templateURL: "http://cloudprint.cainiao.com/template/customArea/440439"
            // }
          ]
        })
      })

      data.task.documents = docs;
      console.log("开始打印", data);
      this.socket.send(JSON.stringify(data));
    },
    onClosed() {
      if (this.socket) this.socket.close();
      this.senderAddress = [];
      this.printerList = [];
      this.printData = [];
    }
  },
};
</script>